/**
 * PodHive loading spinner.
 * - Full screen fixed overlay for global loading states
 * @returns
 */
const LoadingSpinner = () => {
	return (
		<div className="fixed inset-0 z-40 flex items-center justify-center bg-background/80 backdrop-blur-sm">
			<img
				src="/podhive-icon.svg"
				alt="Loading"
				className="w-24 h-24 animate-pulse motion-reduce:animate-none"
				aria-label="Loading..."
				draggable={false}
			/>
		</div>
	);
};

export default LoadingSpinner;
